const SET_COUNTRY_SETTINGS = 'settings/SET_COUNTRY_SETTINGS';
const SET_FEATURE_FLAGS = 'settings/SET_FEATURE_FLAGS';
const SET_INVITE_USER_MODAL_OPENED = 'settings/SET_INVITE_USER_MODAL_OPENED';

export default {
  SET_COUNTRY_SETTINGS,
  SET_FEATURE_FLAGS,
  SET_INVITE_USER_MODAL_OPENED,
};
